/**
 * 트림으로 제거되지 않는 유니코드 공백 특수문자를 제거합니다.
 */
export default function removeZeroWidthWhiteSpace(value: string): string {
  return value.replace(/\u200b/g, '');
}
